module.exports = __webpack_public_path__ + "img/basic_skinmask_tube_202410.1c15167f.jpg";